// extracted by mini-css-extract-plugin
module.exports = {"logo-invision-list":"styles_logo-invision-list__wpJbE","logo-invision":"styles_logo-invision__3IryF","logo-invision-active":"styles_logo-invision-active__3cXmC"};